exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box}#app,body,html{height:100%}", ""]);

// exports
